import { BaseComponent } from '../../components/base-component'
import { delay, $el, transitionToPromise } from '../../utils/utils'
import type { QuantityComponent } from '../../components/quantity-input/quantity'

const CHECKMARK_SELECTOR = `[data-cart-item-checkmark]`
const TOTALS_SELECTOR = `[data-cart-item-totals]`
const QUANTITY_SELECTOR = `[data-cart-item-quantity]`

export class CartItem extends BaseComponent {
  removeItem(): void {
    this.setCollapse(true)
  }

  async expand(): Promise<void> {
    this.setHeight(this.scrollHeight)
    await transitionToPromise(this)
  }

  async collapse(): Promise<void> {
    this.setHeight(0)
    await transitionToPromise(this)
  }

  setCollapse(isCollapsed: boolean) {
    this.classList.toggle('is-new', isCollapsed)
  }

  async showAsNew(): Promise<void> {
    this.setHeight(this.scrollHeight)
    this.setCollapse(false)
  }

  showCheckmark = (): void => {
    const checkmark = $el(CHECKMARK_SELECTOR, this)

    checkmark?.classList.remove('hidden')
    delay(2500).then(() => {
      checkmark?.classList.add('hidden')
    })
  }

  setLoading = (isLoading: boolean): void => {
    const totals = $el(TOTALS_SELECTOR, this)
    totals?.toggleAttribute('is-loading', isLoading)
  }

  setHeight(maxHeight: number): void {
    this.style.maxHeight = `${Math.ceil(maxHeight)}px`
  }

  setDisabled(isDisable: boolean): void {
    const quantity: QuantityComponent = $el(QUANTITY_SELECTOR, this)
    quantity?.setDisable(isDisable)
  }
}
